import React from "react"
import Pulse from './Pulse'
import { isRackType, getDeviceStatus, modelTypeToMarkerProps } from '../../../../pages/Supervision/helpers'

const ParentIcon = ({
  iconSize,
  colors,
  selected = false,
  hovered = false,
  pulse = false,
  connectedDevices = 0,
  deviceType = 'rack',
  device,
  onMouseEnter = () => {},
  onMouseLeave = () => {}
}) => {
  const isRack = isRackType(deviceType)
  const deviceStatus = getDeviceStatus(device)
  const markerProps = modelTypeToMarkerProps({ type: deviceType, available_level: device?.available_level })
  
  const backgroundColor = selected ? colors.active.bgcolor : hovered ? colors.hover.bgcolor : colors.default.bgcolor
  const borderColor = '#292929'

  const actualIconSize = isRack ? iconSize * 1.2 : iconSize
  const badgeSize = isRack ? 12 : 10

  const hasOneChild = device?.children?.length === 1
  const childDevice = hasOneChild ? device.children[0] : null
  const childMarkerProps = childDevice ? modelTypeToMarkerProps({ 
    type: childDevice.model?.type, 
    available_level: childDevice.available_level 
  }) : null

  return (
    <svg
      x={0}
      y={0}
      viewBox={isRack ? "0 0 80 80" : "0 0 56 56"}
      width={actualIconSize}
      height={actualIconSize}
      style={{cursor: 'pointer'}}
      onMouseLeave={onMouseLeave}
      onMouseEnter={onMouseEnter}
    >
      <rect
        x={isRack ? 10 : 4}
        y={isRack ? 10 : 4}
        width={isRack ? 54 : 48}
        height={isRack ? 54 : 48}
        rx={10}
        ry={10}
        fill={backgroundColor}
        stroke={borderColor}
        strokeWidth="2"
        filter="drop-shadow(1px 2px 1px rgba(0, 0, 0, .16))"
      >
        {pulse && (
          <Pulse
            scale={'1 1; 1.1 1.1; 1 1'}
            translate={isRack ? '0 0; -3 -3; 0 0' : '0 0; -2.8 -2.8; 0 0'}
          />
        )}
      </rect>
      
      {isRack ? (
        <foreignObject x={10} y={10} width={54} height={54}>
          <div style={{ 
            width: '100%', 
            height: '100%', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center' 
          }}>
            <i 
              className="fa-solid fa-grid-dividers"
              style={{ 
                fontSize: '32px',
                fontWeight: '600',
                color: 'white'
              }} 
            />
          </div>
        </foreignObject>
      ) : (
        markerProps.icon && (
          <svg x={16} y={16}>
            <image 
              href={markerProps.icon} 
              filter={selected ? colors.active.svgColorFilter : colors.default.svgColorFilter} 
              width={24} 
              height={24}
            />
          </svg>
        )
      )}

      {(connectedDevices > 0 || (!isRack && connectedDevices === 0)) && (
        <>
          <circle
            cx={isRack ? 15 : 46}
            cy={isRack ? 59 : 10}
            r={badgeSize}
            fill="#464646"
            stroke="white"
            strokeWidth="2"
            filter="drop-shadow(1px 1px 1px rgba(0, 0, 0, .16))"
          />
          {isRack ? (
            <foreignObject x={3} y={47} width={24} height={24}>
              <div style={{ 
                width: '100%', 
                height: '100%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center'
              }}>
                <i className="fa-solid fa-list-tree" style={{ fontSize: '10px', color: 'white' }} />
              </div>
            </foreignObject>
          ) : (
            <text
              x={46}
              y={10}
              fill="white"
              fontSize="10px"
              fontWeight="600"
              textAnchor="middle"
              alignmentBaseline="middle"
            >
              {connectedDevices}
            </text>
          )}
        </>
      )}

      {(connectedDevices > 0 || device?.children?.length > 0) && (
        <>
          <circle
            cx={isRack ? 12 : 10}
            cy={isRack ? 60 : 46}
            r={badgeSize}
            fill="#464646"
            stroke="white"
            strokeWidth="2"
            filter="drop-shadow(1px 1px 1px rgba(0, 0, 0, .16))"
          />
         <foreignObject 
            x={isRack ? 0 : -2} 
            y={isRack ? 48 : 34} 
            width={24} 
            height={24}
          >
            <div style={{ 
              width: '100%', 
              height: '100%', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center'
            }}>
              {hasOneChild && childMarkerProps?.icon ? (
                <img 
                  src={childMarkerProps.icon}
                  alt="child device"
                  style={{ 
                    width: 12, 
                    height: 12,
                    filter: 'brightness(0) invert(1)'
                  }}
                />
              ) : (
                <i className="fa-solid fa-list-tree" style={{ fontSize: '10px', color: 'white' }} />
              )}
            </div>
          </foreignObject>
        </>
      )}
    </svg>
  )
}

export default ParentIcon